import { Component, CUSTOM_ELEMENTS_SCHEMA, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { FormsModule } from '@angular/forms';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'app-firwmare',
  standalone: true,
  imports: [TranslatePipe, FormsModule],
  templateUrl: './firwmare.component.html',
  styleUrl: './firwmare.component.scss',
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class FirwmareComponent implements OnInit {
  version: string = '';  
  mac: any;

  constructor(private route: ActivatedRoute,
    private router: Router) {}

  ngOnInit(): void {
    this.version = 'rc';
  }

  back() {
		setTimeout(() => {
			this.router.navigate(['/']);			
		}, 150);
	}

  flash() {
    console.log('flash request for ', this.version);
  }
}